<ion-card class="d-flex flex-column align-items-center justify-content-between h-100" [color]="color">
    <cwt-image [src]="image" width="90%" ratio="1" shape="circle">
        <cwt-loading-addon *cwtMediaAddon="'loading'"></cwt-loading-addon>
        <cwt-image *cwtMediaAddon="'placeholder'" width="100%" src="/assets/img/logo_placeholder.png"></cwt-image>
        <!-- <cwt-icon-addon *cwtImageAddon="'placeholder'"></cwt-icon-addon> -->
    </cwt-image>
    <ion-text class="align-self-stretch text-center mt-2" color="dark">{{title}}</ion-text>
    <ion-ripple-effect *ngIf="ripple" class="custom_color"></ion-ripple-effect>
</ion-card>